import React, { useState } from "react";
import getConfig from "next/config";
import Link from "next/link";

import ArrowDown from "@components/Icons/ArrowDown";

const {
  publicRuntimeConfig: {
    settings,
    content: {
      supportMenuLinks: { stores, contact },
    },
  },
} = getConfig();

const Categories = ({ items }) => {
  const [activeDropdowns, setActiveDropdowns] = useState([]);

  if (!items || !items.length) {
    return null;
  }

  // THIS IS A TEMP HACK BECAUSE REASONS
  // REMOVE WHEN https://axsysro.atlassian.net/browse/ECOMDEV-2495 IS DONE
  // PAY ATTENTION TO ROUTE KEY, IT IS TEMP
  const tempItems = [
    ...items.slice(0, 3),
    {
      name: "Sesizari si reclamatii",
      children: [
        {
          name: "Formular contact",
          children: [],
          slug: "formular-contact",
          route: "contact",
        },
        {
          name: "Returneaza produse",
          children: [],
          route: "cont/retururi",
          slug: "returneaza-produse",
        },
      ],
      slug: "sesizari-si-reclamatii",
    },
    ...items.slice(3),
  ];

  const renderCategory = (item, i, hiddenOnDesktop = false) => {
    const articles = item.children || item.links;

    return (
      <div
        key={item.name}
        className={`
        md:px-10 md:mt-12 md:pt-1
      border-gray-1100 border md:border-0
        ${i == items.length + 1 ? "rounded-bl-lg" : ""}
        ${i == 0 ? "border-t rounded-tr-lg" : "border-t-0"}
        ${hiddenOnDesktop ? "md:hidden" : ""}
      `}
      >
        <div
          className={`
          flex justify-between items-center cursor-pointer md:pointer-events-none px-4 py-2 md:p-0
          border-l-4 md:border-0
          ${
            activeDropdowns.includes(i)
              ? "border-primary"
              : "border-transparent"
          }
          `}
          onClick={() => {
            if (activeDropdowns.includes(i)) {
              let active = activeDropdowns.filter((a) => a != i);
              setActiveDropdowns([...active]);
            } else {
              setActiveDropdowns([...activeDropdowns, i]);
            }
          }}
        >
          <h2
            className={`
            md:mb-3 font-normal text-sm md:text-3xl -lg:tracking-0.67 -tracking-0.39
            ${
              activeDropdowns.includes(i)
                ? "text-newGray-mildDark md:text-black"
                : ""
            }
          `}
          >
            {item.name}
          </h2>

          <span
            className={`duration-75 ${
              activeDropdowns.includes(i) ? "rotate-180" : ""
            }  ml-2 md:hidden`}
          >
            <ArrowDown />
          </span>
        </div>

        <ul
          className={`
          text-sm md:block px-10 pt-3 pb-4 md:p-0 border-gray-1100 border-t md:border-t-0
          ${activeDropdowns.includes(i) ? "" : "hidden"}
        `}
        >
          {articles.map((article) => (
            <li key={article.slug} className="pt-1 pb-1">
              {/* THIS IS A TEMP HACK BECAUSE REASONS
              REMOVE WHEN https://axsysro.atlassian.net/browse/ECOMDEV-2495 IS DONE
              PAY ATTENTION TO ROUTE KEY, IT IS TEMP
              REMOVE ARTICLE.ROUTE IF/ELSE LOGIC!!
              */}
              {article.route ? (
                <Link href={`${settings.baseUrl}/${article.route}/`} passHref>
                  <a className="inline-block text-black hover:text-newGray-mildDark leading-24px -tracking-0.29">
                    {article.name}
                  </a>
                </Link>
              ) : (
                <Link
                  href={
                    item.children
                      ? `${settings.baseUrl}/suport-clienti/${article.slug}/`
                      : `${settings.baseUrl}${article.slug}`
                  }
                  passHref
                >
                  <a className="inline-block text-black hover:text-newGray-mildDark leading-24px -tracking-0.29">
                    {article.name}
                  </a>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <div className="mt-6">
        <div className="md:flex md:flex-wrap md:justify-center">
          {tempItems.map((item, i) => renderCategory(item, i))}
          {renderCategory(stores, tempItems.length, true)}
          {renderCategory(contact, tempItems.length + 1, true)}
        </div>
      </div>
    </>
  );
};

export default Categories;
